import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
// Mobile detector
const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
const Authentication = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [userType, setUserType] = useState('buyer');
  return <div className="min-h-screen bg-gray-50 flex flex-col" data-id="element-975">
      <div className="p-4" data-id="element-976">
        <Link to="/" className="flex items-center text-gray-600 hover:text-gray-900" data-id="element-977">
          <ArrowLeftIcon size={20} className="mr-2" data-id="element-978" />
          Back to Home
        </Link>
      </div>
      <div className="flex-grow flex items-center justify-center px-4 py-8" data-id="element-979">
        <div className={`bg-white rounded-xl shadow-xl overflow-hidden max-w-4xl w-full ${isMobile ? 'flex-col' : 'flex flex-col md:flex-row'}`} data-id="element-980">
          {/* Left panel - simplified for mobile */}
          <div className={`bg-[#1A1F47] text-white p-8 ${isMobile ? '' : 'md:w-2/5'} flex flex-col justify-between`} data-id="element-981">
            <div data-id="element-982">
              <div className="flex items-center mb-6" data-id="element-983">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5x5PaY9EQXtKFDVPyyMPNt/Veriprop_logo.png" alt="VeriProp Logo" className="h-8 w-auto mr-2" data-id="element-984" />
                <span className="text-xl font-bold" data-id="element-985">VeriProp</span>
              </div>
              <h2 className="text-2xl font-bold mb-4" data-id="element-986">
                {isLogin ? 'Welcome Back!' : 'Join Our Community'}
              </h2>
              {!isMobile && <p className="mb-6" data-id="element-987">
                  {isLogin ? 'Sign in to access your account and continue your journey to property ownership in Nigeria.' : 'Create an account to start your secure journey to owning property in Nigeria from anywhere in the world.'}
                </p>}
            </div>
            <div className="mt-8" data-id="element-988">
              <p className="text-sm opacity-80" data-id="element-989">
                "We are not just building an app—we are building a trusted
                bridge between the hearts of Nigerians abroad and their roots at
                home."
              </p>
            </div>
          </div>
          {/* Right panel - form */}
          <div className={`p-6 ${isMobile ? '' : 'md:w-3/5'}`} data-id="element-990">
            <div className="mb-6" data-id="element-991">
              <h1 className="text-xl font-bold text-gray-800 mb-2" data-id="element-992">
                {isLogin ? 'Sign In to Your Account' : 'Create Your Account'}
              </h1>
              <p className="text-gray-600 text-sm" data-id="element-993">
                {isLogin ? 'Enter your credentials to access your account' : 'Fill in your details to get started'}
              </p>
            </div>
            {!isLogin && <div className="mb-6" data-id="element-994">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-995">
                  I am a:
                </label>
                <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-996">
                  {['buyer', 'agent'].map(type => <button key={type} className={`py-3 px-4 rounded-lg border ${userType === type ? 'bg-[#FF4E00] bg-opacity-10 border-[#FF4E00] text-[#FF4E00]' : 'border-gray-300 hover:bg-gray-50'}`} onClick={() => setUserType(type)} data-id="element-997">
                      {type === 'buyer' ? 'Property Buyer' : 'Real Estate Agent'}
                    </button>)}
                </div>
                {['law firm', 'service provider'].map(type => <button key={type} className={`py-3 px-4 rounded-lg border w-full mb-2 ${userType === type ? 'bg-[#FF4E00] bg-opacity-10 border-[#FF4E00] text-[#FF4E00]' : 'border-gray-300 hover:bg-gray-50'}`} onClick={() => setUserType(type)} data-id="element-998">
                    {type === 'law firm' ? 'Law Firm' : 'Service Provider'}
                  </button>)}
              </div>}
            <form className="space-y-4" data-id="element-999">
              {!isLogin && <>
                  <div className={`${isMobile ? 'space-y-4' : 'grid grid-cols-2 gap-4'}`} data-id="element-1000">
                    <div data-id="element-1001">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1002">
                        First Name
                      </label>
                      <input type="text" className="w-full px-3 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF4E00]" data-id="element-1003" />
                    </div>
                    <div data-id="element-1004">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1005">
                        Last Name
                      </label>
                      <input type="text" className="w-full px-3 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF4E00]" data-id="element-1006" />
                    </div>
                  </div>
                </>}
              <div data-id="element-1007">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1008">
                  Email Address
                </label>
                <input type="email" className="w-full px-3 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF4E00]" data-id="element-1009" />
              </div>
              <div data-id="element-1010">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1011">
                  Password
                </label>
                <input type="password" className="w-full px-3 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF4E00]" data-id="element-1012" />
              </div>
              {!isLogin && <div data-id="element-1013">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1014">
                    Confirm Password
                  </label>
                  <input type="password" className="w-full px-3 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF4E00]" data-id="element-1015" />
                </div>}
              <button type="submit" className="w-full py-3 px-4 bg-[#FF4E00] text-white font-medium rounded-lg hover:bg-[#e64600] focus:outline-none focus:ring-2 focus:ring-[#FF4E00] focus:ring-offset-2" data-id="element-1016">
                {isLogin ? 'Sign In' : 'Create Account'}
              </button>
            </form>
            <div className="mt-6 text-center" data-id="element-1017">
              <p className="text-gray-600" data-id="element-1018">
                {isLogin ? "Don't have an account? " : 'Already have an account? '}
                <button className="text-[#FF4E00] font-medium hover:underline" onClick={() => setIsLogin(!isLogin)} data-id="element-1019">
                  {isLogin ? 'Sign Up' : 'Sign In'}
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default Authentication;